import { useState } from "react";
import { Box, Button } from "@mui/material";
import { FolderArrowDownIcon } from "@heroicons/react/24/outline";
import { SubmitButton } from "@components";
import { dataSyncService } from "features/dataSync/services/data-sync-service";
import { useWaitingOverlay } from "@hooks/waitingOverlay";
import usePersistedState from "@hooks/usePersistedState";
import useFileDownloader from "features/dataSync/hooks/useFileDownloader";
import { buttonsRowStyle, buttonAStyle } from "./styles";

const getFormattedDateNow = () => {
  const now = new Date();

  // Format the date and time
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

export const GenerateTranslations = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [id, setId] = useState<string>();
  const { showWait } = useWaitingOverlay();
  const { downloadFile, isLoading } = useFileDownloader();
  const defaultFiltersState = {
    dateCreated: "",
    id: "",
  };

  const { state: translationState, setState: setTranslationState } = usePersistedState(
    "lastTranslationFile",
    defaultFiltersState,
    "session",
  );

  const { id: idSession, dateCreated } = translationState;
  const fileId = id ?? idSession;

  const handleTask = async () => {
    setIsProcessing(true);

    try {
      showWait();
      const responseId = await dataSyncService.runGenerateTranslations();
      setId(responseId);
      setTranslationState({
        id: responseId,
        dateCreated: getFormattedDateNow(),
      });
    } catch (error) {
      console.error(error);
    } finally {
      setIsProcessing(false);
    }
  };

  const onFileDownload = async () => {
    try {
      const url = `${window.appConfig.baseUrl}/File/download-file/${fileId}`;
      await downloadFile(url, fileId);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <p>Generate translation.</p>
      <Box sx={buttonsRowStyle}>
        <SubmitButton isProcessing={isProcessing} onClick={handleTask}>
          Run Translation Task
        </SubmitButton>
      </Box>
      {fileId ? (
        <Box sx={buttonsRowStyle}>
          <Box>Archive ready to download {dateCreated ? `(${dateCreated})` : null}:</Box>
          <Button
            disabled={isLoading}
            variant="contained"
            endIcon={<FolderArrowDownIcon width={20} height={20} />}
            onClick={onFileDownload}
            sx={buttonAStyle}
          >
            Download archive
          </Button>
        </Box>
      ) : null}
    </>
  );
};
